// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top[data-v-96e13b9c]{display:flex;justify-content:space-between;margin-bottom:20px}.editBox[data-v-96e13b9c]{font-size:15px;display:flex;justify-content:space-around}.editBox .el-icon-close[data-v-96e13b9c]{color:red}.editBox .el-icon-check[data-v-96e13b9c]{color:green}.createBox[data-v-96e13b9c]{display:flex;margin-bottom:20px}.paging[data-v-96e13b9c]{display:flex;padding:15px;flex-direction:row-reverse}", ""]);
// Exports
module.exports = exports;
